var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_vm._v(_vm._s(_vm.producto.nombre_producto)+" "),_c('br'),_vm._v("Cantidad: "+_vm._s(_vm.producto.cantidad_producto)+" unidades"),_c('br'),_vm._v("Precio: $"+_vm._s(_vm.producto.precio_producto)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }